import { Injectable } from "@angular/core";
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { CredentialsMaintenanceComponent } from "../credentials-maintenance.component";

@Injectable({
  providedIn: "root",
})
export class PrevenRouteChange
  implements CanDeactivate<CredentialsMaintenanceComponent>
{
  canDeactivate(
    component: CredentialsMaintenanceComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean {
    if (component.isRecertify && !this.isCredentialSubPage(nextState)) {
      return window.confirm(
        "You didn’t ‘Recertify Now’. Are you sure you want to exit?"
      );
    }
    return true;
  }

  private isCredentialSubPage(nextState: RouterStateSnapshot): boolean {
    return (
      nextState.url.includes("credentials-maintenance") ||
      nextState.url === "/purchase/checkout/certification?isRecertify=true"
    );
  }
}
